import React from "react";
import { useTranslation } from "react-i18next";

import CustomCheckbox from "../../shared/custom-components/checkbox";
import CustomSelect from "../../shared/custom-components/customSelect";
import StepButtons from "./stepButtons";
import useForm from "../../hooks/useForm";

const ServiceForm = ({
  initialState = {},
  nextStep,
  previousStep,
  reviewMode,
}) => {
  const { setValue, onSubmit, values } = useForm({
    initialState,
    callback: nextStep,
  });
  const { t } = useTranslation();

  const handleChangeRelation = ({ target: { name, value } }) => {
    setValue(name, { checked: values[name].checked, approvers: value });
  };

  return (
    <>
      <h3 className="form-title">{t(`${baseName}title`)}</h3>
      <div className="d-flex justify-content-between flex-wrap">
        {titles.map((item) => (
          <div
            key={item}
            className={`width-column form-title mb-3 text-left ${
              reviewMode ? "mt-3" : ""
            }`}
          >
            {`${t(`${baseName}${item}`)}`}
          </div>
        ))}
        {options.map((name) => (
          <div
            className="w-100 d-flex justify-content-between align-items-center flex-wrap"
            key={name}
          >
            <div className="width-column fix-padding-checkbox">
              <CustomCheckbox
                label={t(`${baseName}${name}`)}
                disabled={true}
                checked={values[name]["checked"]}
                name={name}
                id={name}
              />
            </div>
            <div className="width-column">
              <CustomSelect
                items={items}
                disabled={reviewMode}
                value={values[name]["approvers"]}
                name={name}
                onChange={handleChangeRelation}
                id={name}
              />
            </div>
          </div>
        ))}
        <div className="w-100 d-flex justify-content-between flex-wrap mt-4">
          <div className="width-column">
            {optionsBotton.map((name, index) => (
              <div key={name} className={index ? "mt-4" : ""}>
                <CustomCheckbox
                  label={t(`${baseName}${name}`)}
                  disabled={true}
                  name={name}
                  checked={values[name]}
                  id={name}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      {!reviewMode && (
        <StepButtons nextStep={onSubmit} previousStep={previousStep} />
      )}
    </>
  );
};

export default ServiceForm;

const titles = ["leftTitle", "rightTitle"];

const options = ["modUser", "modBills", "modRelations"];

const optionsBotton = [/*"modLogs",*/ "modReports"];

const items = [
  { label: 0, value: 0 },
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
];

const baseName = "registerProvider.forms.service.";
